import _isEmpty from 'lodash/isEmpty';

export default function removeEmptyObjProps(obj: any): any {
  return Object.entries(obj)
    .filter(([_, v]) => v != null)
    .reduce((acc, [k, v]) => ({ ...acc, [k]: v === Object(v) ? removeEmptyObjProps(v) : v }), {});
}
